import axios from "axios";

export const getBatchPlanSuggestions = async () => {
  const response = await axios.get("batch-planning/suggestions");
  return response.data;
};

export const getEligibleJobs = async (filters = {}) => {
  const response = await axios.get("batch-planning/eligible-jobs", { params: filters });
  return response.data;
};

export const getPlannedBatches = async (filters = {}) => {
  const response = await axios.get("batch-planning/batches", { params: filters });
  return response.data;
};

export const createPlannedBatch = async (jobIds, notes) => {
  const response = await axios.post("batch-planning/create", {
    job_ids: jobIds,
    notes,
  });
  return response.data;
};

export const getBatchMRP = async (batchId) => {
  const response = await axios.get(`batch-planning/${batchId}/mrp`);
  return response.data;
};

export const generateBatchInstructions = async (batchId) => {
  const response = await axios.post(`batch-planning/${batchId}/instructions`);
  return response.data;
};

export const saveBatchInstructions = async (batchId) => {
  const response = await axios.post(`batch-planning/${batchId}/instructions/save`);
  return response.data;
};

export const getSavedInstructions = async (batchId) => {
  const response = await axios.get(`batch-planning/${batchId}/instructions`);
  return response.data;
};

export const addJobsToBatch = async (batchId, jobIds) => {
  const response = await axios.post(`batch-planning/${batchId}/add-jobs`, {
    job_ids: jobIds,
  });
  return response.data;
};

export const removeJobFromBatch = async (batchId, jobId) => {
  const response = await axios.post(`batch-planning/${batchId}/remove-job`, {
    job_id: jobId,
  });
  return response.data;
};

export const moveJobBetweenBatches = async (fromBatchId, toBatchId, jobId) => {
  const response = await axios.post("batch-planning/move-job", {
    from_batch_id: fromBatchId,
    to_batch_id: toBatchId,
    job_id: jobId,
  });
  return response.data;
};

export const deletePlannedBatch = async (batchId) => {
  const response = await axios.delete(`batch-planning/${batchId}`);
  return response.data;
};

export const updateBatchStatus = async (batchId, status) => {
  const response = await axios.put(`batch-planning/${batchId}/status`, { status });
  return response.data;
};

export const getBatchesForKanban = async (filters = {}) => {
  const response = await axios.get("batch-planning/kanban", { params: filters });
  return response.data;
};

export const getBatchById = async (batchId) => {
  const response = await axios.get(`batch-planning/${batchId}/detail`);
  return response.data;
};

export const moveBatchStage = async (batchId, toStage, stageCompletion = null) => {
  const response = await axios.post(`batch-planning/${batchId}/move-stage`, {
    to_stage: toStage,
    stage_completion: stageCompletion,
  });
  return response.data;
};

export const setBatchLock = async (batchId, locked) => {
  const response = await axios.patch(`batch-planning/${batchId}/lock`, { locked });
  return response.data;
};

export const getBoxSizeSuggestion = async (jobId) => {
  const response = await axios.get(`batch-planning/box-size-suggestion/${jobId}`);
  return response.data;
};

export const createInstructionLog = async (payload) => {
  const response = await axios.post("batch-planning/instruction-log", payload);
  return response.data;
};

export const getInstructionLogs = async (params = {}) => {
  const response = await axios.get("batch-planning/instruction-logs", { params });
  return response.data;
};

// batchIds: optional array of batch IDs to include; omit to get all active batches (for the picker)
export const getStageInstructions = async (stageCode, batchIds = null) => {
  const params = { stage_code: stageCode };
  if (batchIds && batchIds.length > 0) params.batch_ids = batchIds.join(",");
  const response = await axios.get("batch-planning/stage-instructions", { params });
  return response.data;
};
